import { render, staticRenderFns } from "./NViewTable.vue?vue&type=template&id=2ed7a902&scoped=true&"
import script from "./NViewTable.vue?vue&type=script&lang=js&"
export * from "./NViewTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed7a902",
  null
  
)

export default component.exports